if ($(".js-dropdown").length) {
    App.H.on("click", ".js-dropdown-button", function () {
        const $dropdown = $(this).closest(".js-dropdown");
        const $dropdownContent = $(this).siblings(".js-dropdown-content");

        if ($dropdown.hasClass("_opened")) {
            $dropdown.removeClass("_opened");
            $dropdownContent.slideUp(150);

            if (App.W.width() < 768) {
                App.lockScroll.unlock();
            }
            return;
        }

        if ($dropdown.siblings(".js-dropdown").hasClass("_opened")) {
            $dropdown.siblings(".js-dropdown._opened").find('.js-dropdown-button').trigger('click');
        }

        $dropdown.addClass("_opened");
        $dropdownContent.slideDown(150);

        if (App.W.width() < 768) {
            App.lockScroll.lock();
        }
    });

    App.H.on("click", function (e) {
        const $openedDropdowns = $(".js-dropdown._opened");

        if ($openedDropdowns.length > 1) {
            const clickedDropdownDom = $(e.target).closest(".js-dropdown").get(0);

            $openedDropdowns
                .filter((_, dropdownDom) => dropdownDom !== clickedDropdownDom)
                .removeClass("_opened")
                .find(".js-dropdown-content")
                .slideUp(150);
        }

        if (
            !$(this).hasClass(".js-dropdown") &&
            !$(e.target).parents().addBack().is(".js-dropdown") &&
            App.H.find(".js-dropdown._opened")
        ) {
            $(".js-dropdown._opened").removeClass("_opened");
            $(".js-dropdown-content").slideUp(150);

            if (App.W.width() < 768) {
                App.lockScroll.unlock();
            }
        }
    });
}
